import { Badge } from '@localagent/ui/components/badge';

const STATUS_VARIANT: Record<string, 'success' | 'warning' | 'destructive' | 'secondary'> = {
  active: 'success',
  pending_auth: 'warning',
  expired: 'destructive',
  disabled: 'secondary',
  auth_failed: 'destructive',
};

export function ConnectionStatusBadge({ status }: { status: string }) {
  const variant = STATUS_VARIANT[status] ?? 'secondary';
  return (
    <Badge variant={variant}>
      {status.replace(/_/g, ' ')}
    </Badge>
  );
}
